import { useMemo } from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import EventModal from './EventModal';
import { postATask } from '@/_redux/actions/ActionTasks';
import { toast } from 'react-toastify';
export const filterTeams = ({ isAdmin, teamList = [], roomList = [] }) => {
    const teamMap = new Map();
    const allTeams = new Map(
        teamList.filter((entry) => entry?.team && entry?.team?._id).map((entry) => [entry.team._id, entry.team])
    );
    const managerTeamIds = new Set();

    if (isAdmin) {
        return {
            teamList: Array.from(allTeams.values()),
            teamIds: Array.from(allTeams.keys()),
        };
    }

    // Add teams where user is owner/teamManager
    for (const { role, team } of teamList) {
        if (!team?._id) continue;
        if (role === 'owner' || role === 'teamManager') {
            teamMap.set(team._id, team);
            managerTeamIds.add(team._id);
        }
    }

    // Add teams linked to rooms where user is a supervisor, if not already added
    for (const { role, room } of roomList) {
        const teamId = room?.team;
        if (role !== 'supervisor' || !teamId || managerTeamIds.has(teamId)) continue;
        if (!teamMap.has(teamId) && allTeams.has(teamId)) {
            teamMap.set(teamId, allTeams.get(teamId));
        }
    }

    return {
        teamList: Array.from(teamMap.values()),
        teamIds: Array.from(teamMap.keys()),
    };
};

const CreateEvent = ({ CurrUser, teams, fetchUpcomingTasks = () => {}, postATask }) => {
    const userRole = useMemo(() => {
        return CurrUser?.role;
    }, [CurrUser]);

    const userEventCreateTeams = useMemo(() => {
        return filterTeams({
            isAdmin: CurrUser?.role === 'admin',
            teamList: CurrUser?.teamList || [],
            roomList: CurrUser?.roomList || [],
        });
    }, [CurrUser]);

    const handleSubmitTask = async (task) => {
        try {
            let creator = {
                avatar: CurrUser.avatar,
                id: CurrUser.id,
                name: CurrUser.name,
                onlineStatus: CurrUser.onlineStatus,
            };
            const TODAY = dayjs().format('YYYY-MM-DD');
            const selectedMonthYear = dayjs(TODAY).format('YYYY-MM');
            const response = await postATask(task, creator, selectedMonthYear);
            return response;
        } catch (error) {
            toast.error(error.message);
        } finally {
            fetchUpcomingTasks();
        }
    };

    return (
        <EventModal
            teamIds={userRole === 'admin' ? teams.map((t) => t._id) : userEventCreateTeams?.teamIds || []}
            customTeams={userRole === 'admin' ? null : userEventCreateTeams?.teamList || []}
            handleSubmitTask={handleSubmitTask}
        />
    );
};

const mapStateToProps = (state) => ({
    CurrUser: state.user.user,
    tasks: state.tasks,
    teams: state.teams.teams,
});

export default connect(mapStateToProps, {
    postATask,
})(CreateEvent);
